<template>
    <div>
        <div v-if="download">
            <h5 :columns="6">Select specialist type for download</h5>
            <amf-validation-wrapper :validator="$v.specialistTypeSelected">
                <div v-for="specialist in this.employerSpecialistTypes" :key="specialist.dto" class="col-12 mb-1">
                    <div class="flex-row">
                        <input class="mt-1 mr-2" name="specialistType" type="radio" :value="specialist.dto" v-model="specialistTypeSelected">
                        <label>{{specialist.displayTitle}}</label>
                    </div>
                </div>
            </amf-validation-wrapper>
        </div>
        <div v-if="upload" style="text-align: center">
            <h5 :columns="3">Please upload your file in CSV format.</h5>
            <div class="p-1">
                <label class="btn btn-success btn-file">
                    Upload your employer specialist changes file <input type="file" ref="uploader" style="display: none;" @change="onFileSelect" />
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        props: [
            "title",
            "download",
            "upload",
            "blank",
        ],
        computed: {
            ...amfx.map('employer/specialists', "employerSpecialistTypes"),
            buttons() {
                return this.download == true ? 'OK/Cancel' : 'Cancel';
            },
        },
        data(){
            return{
                   specialistTypeSelected: null,
            }
        },
        methods: {
            async ok(){   
                await await romeApi.download(`/employers/representatives/${this.specialistTypeSelected}/download/${this.blank}`); 
            }, 
            async onFileSelect() {
                let selectedFile = this.$refs.uploader.files[0];

                if(!selectedFile) return;
                
                let formData = new FormData();
                formData.append('file', selectedFile);

                let messages = await romeApi.upload(`employer/representatives/upload`, formData);

                if(messages && messages.length > 0){
                    await modalService.multiLineInfo(messages, undefined, 'Employer Specialist Updates Outcome', true);
                } 
                else{
                    await modalService.multiLineInfo(['No changes were submitted for processing'], undefined, 'Employer Specialist Updates Outcome', true);
                }
                this.$refs.uploader.value = null;
                this.$parent.close();
            },
        },
        validations() {
            return {    
                specialistTypeSelected: v.build(v.required())
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/employer/EmployerSpecialistTypeModal.vue